import VueLazyLoad from 'vue3-lazyload'

export default ({ app }) => {
  app.use(VueLazyLoad, {
    preLoad: 1.1,
    attempt: 1,
    lazyComponent: true,
  })
}
